<div class="block-wrapper w-100" [style.height.px]="block.settings.size"></div>
